import React from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

import WorkerCard from '../widgets/WorkerCard';




export default function (props) {
	const { t, i18n } = useTranslation("",{lng: props.language});

  	return (
		  	<>		
				<section class="about">	  

					<center>
						<h2 style={{paddingTop: "40px"}} class="headlineNewPoint">{t("StartPageSlogan1")}</h2>
					</center>
										
					<Box sx={{	display: 'flex', 
								flexDirection: 'row', 
								pt: 2,
								display: {
									xs: 'none',
									sm: 'none',  
									md: 'block',  
									lg: 'block',  
									xl: 'block',  
									
							}   }}>
			      		<Grid container style={{paddingTop: "0px"}}>
			        		<Grid item xs={12}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={3}>
					        			<Paper>
					        				<WorkerCard  header="Meisterbetrieb Heizung Sanitär" subline="Alles rund im Ihre Heizung"  url="https://heizung-sanitaer-doetsch.de/" logo="/assets/doetsch.png"/>					        				
					        			</Paper>
						     	   </Grid>
					        		<Grid item xs={3}>
					        			<Paper>
					        				<WorkerCard header="Meisterbetrieb Tischlerei" subline="Wir machen in Holz"  url="https://www.nengel.info/" logo="/assets/negel.png"/>					        				
					        			</Paper>
						     	   </Grid>
					        		<Grid item xs={3}>
					        			<Paper>
					        				<WorkerCard header="Meisterbetrieb für Sanitär- & Heiztechnik" subline="Wir sorgen für Wärme"  url="https://krech-sanitaer.de/"  logo="/assets/krech.png"/>					        				
					        			</Paper>
						     	   </Grid>
					        		<Grid item xs={3}>
					        			<Paper>
			        				<WorkerCard  header="Dachdeckermeister Martin" subline="Wir kümmern uns um ihr Dach"  url="https://dachdeckermeister-martin.de/" logo="/assets/martin.png"/>					        				
					        			</Paper>
						     	   </Grid>
					     	   </Grid>
				     	   </Grid>
			     	   	</Grid>		
					</Box>
					<Box sx={{	display: 'flex', 
								flexDirection: 'row', 
								pt: 2,
								display: {
									xs: 'block',
									sm: 'block',  
									md: 'none',  
									lg: 'none',  
									xl: 'none',  
									
							}   }}>
			        			<Paper>
			        				<WorkerCard  header="Meisterbetrieb Heizung Sanitär" subline="Alles rund im Ihre Heizung"  url="https://heizung-sanitaer-doetsch.de/" logo="/assets/doetsch.png"/>					        				
			        			</Paper>
			        			<Paper>
			        				<WorkerCard header="Meisterbetrieb Tischlerei" subline="Wir machen in Holz"  url="https://www.nengel.info/" logo="/assets/negel.png"/>					        				
			        			</Paper>
			        			<Paper>
			        				<WorkerCard header="Meisterbetrieb für Sanitär- & Heiztechnig" subline="Wir sorgen für Wärme"  url="https://krech-sanitaer.de/"  logo="/assets/krech.png"/>					        				
			        			</Paper>
			        			<Paper>
			        				<WorkerCard  header="Dachdecker-meister Martin" subline="Wir kümmern uns um ihr Dach"  url="https://dachdeckermeister-martin.de/" logo="/assets/martin.png"/>					        				
			        			</Paper>
							
					</Box>	
			  	</section>
		  </>
	  )
}